<div style="height: 100dvh; width: 100dvw; display: flex; flex-direction: column">
  <div class="position-relative">
    <div class="header-div">
      <div class="left-side">
        <div class="heading">
          <div class="title-bg">
            <div class="title-img"></div>
          </div>
          <div class="side-title">Philanthropy</div>
        </div>
      </div>
      <!-- <div class="right-side">
        <button class="sat-primary-btn">Login</button>
      </div> -->
    </div>

    <div class="sidebar">
      <div class="first">
        <span routerLink="home" routerLinkActive="active">Home</span>
        <span routerLink="privacy-policy" routerLinkActive="active">Privacy Policy</span>
        <span routerLink="refund-policy" routerLinkActive="active">Refund Policy</span>
        <span routerLink="contact-us" routerLinkActive="active">Contact us</span>
        <span routerLink="terms-and-conditions" routerLinkActive="active">Terms and Conditions</span>
      </div>

      <!-- <div class="second">
        <button class="sat-primary-btn" (click)="onLogin()">Login</button>
      </div> -->

    </div>
  </div>

  <div class="routerBody">
    <router-outlet></router-outlet>
  </div>
</div>